import React from 'react';
import AppStore from 'AppStore';

import * as Strings from '../../utils/strings';
import CustomText from '../../common/components/CustomText';
import CustomButton from '../../common/components/CustomButton';
import { getLease } from './PortfolioActions';

import './Portfolio.css';

export default class Lease extends React.Component {
    constructor() {
        super();
        this.state = {
            portfolio: null,
            lease: null
            // lease: {
            //     vendorName: 'Example Company',
            //     vendorInvoice: 60000,
            //     purchaseOptionDate: '2018-03-01',
            //     purchaseOptionAmount: 60,
            //     paymentBeforeTax: 8000,
            //     leaseStartDate: '2018-03-01',
            //     leaseNumber: 'L-002727',
            //     leaseId: 'a070x000000U1KwAAK',
            //     leaseEndDate: '2019-03-01',
            //     fullTerm: 12,
            //     assets: 'Agricultural;Air Compressor;Air Cleaning'
            // }
        };
    }

    componentWillMount = () => {
        AppStore.on('lease_retrieved', this.onLeaseRetrieved);
        const cb = () => {
            getLease(this.props.match.params.leaseId);
        };
        setTimeout(cb, 500);
    };

    componentWillUnmount = () => {
        AppStore.removeListener('lease_retrieved', this.onLeaseRetrieved);
    };
    onLeaseRetrieved = () => {
        const lease = AppStore.getAppState().lease;
        this.setState({ lease: lease });
    };

    render() {
        if (!this.state.lease) {
            return (
                <div className="hack">
                    <div id="app-container">
                        <center>loading...</center>
                    </div>
                </div>
            );
        }

        const payload = this.state.lease;

        return (
            <div className="more hack">
                <div id="app-container">
                    <div id="quotes-container" className="form-container">
                        <div className="select-quote-options">
                            <h2>
                                <center>Lease Information</center>
                            </h2>
                            <br />

                            <div className="row select-term">
                                <CustomText
                                    label="Lease#"
                                    textValue={payload.leaseNumber}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Lease Start Date"
                                    textValue={payload.leaseStartDate}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Full Term Lease"
                                    textValue={payload.fullTerm}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Vendor"
                                    textValue={payload.vendorName}
                                    customRef="1"
                                />

                                <CustomText
                                    label="Vendor Invoice"
                                    textValue={payload.vendorInvoice}
                                    customRef="1"
                                    format="currency"
                                />
                                <CustomText
                                    label="Asset Description"
                                    textValue={payload.assets}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Payment"
                                    textValue={payload.paymentBeforeTax}
                                    customRef="1"
                                    format="currency"
                                />
                                <CustomText
                                    label="Purchase Option Date"
                                    textValue={payload.purchaseOptionDate}
                                    customRef="1"
                                />
                                <CustomText
                                    label="Purchase Option Amount"
                                    textValue={payload.purchaseOptionAmount}
                                    customRef="1"
                                    format="currency"
                                />

                                <CustomText
                                    label="Lease End Date"
                                    textValue={payload.leaseEndDate}
                                    customRef="1"
                                />
                            </div>
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/Lease.jsx